import { GoogleAdProvider } from '../providers/GoogleAdProvider';
import type { IAdProvider } from '../types/ad-manager.interfaces';

let provider: IAdProvider | undefined;

export interface UseAdManagerReturn {
	provider: IAdProvider;
}

export const useAdManager = (): UseAdManagerReturn => {
	if (!provider) {
		provider = new GoogleAdProvider();
	}
	return {
		provider,
	};
};

/**
 * Reset singletons — **only for tests**.
 */
export const _resetAdManager = (): void => {
	provider = undefined;
};
